const RtVideo = (function () {
  const PLYR_CSS_URL = "https://cdn.plyr.io/3.7.8/plyr.css";
  const PLYR_JS_URL = "https://cdn.plyr.io/3.7.8/plyr.polyfilled.js";

  const hasRtAttr = (el, attr) => {
    return (
      el.hasAttribute(`data-rt-video-${attr}`) ||
      el.hasAttribute(`rt-video-${attr}`)
    );
  };

  const getRtAttr = (el, attr) => {
    if (el.hasAttribute(`data-rt-video-${attr}`))
      return el.getAttribute(`data-rt-video-${attr}`);
    if (el.hasAttribute(`rt-video-${attr}`))
      return el.getAttribute(`rt-video-${attr}`);
    return null;
  };

  const injectStyles = () => {
    if (!document.querySelector(`link[href="${PLYR_CSS_URL}"]`)) {
      const plyrCss = document.createElement("link");
      plyrCss.rel = "stylesheet";
      plyrCss.href = PLYR_CSS_URL;
      document.head.appendChild(plyrCss);
    }

    if (!document.getElementById("rt-video-custom-css")) {
      const customCss = document.createElement("style");
      customCss.id = "rt-video-custom-css";
      customCss.textContent = `
        [data-rt-video] > video.rt-generated-video,
        [rt-video] > video.rt-generated-video,
        [data-rt-video] > div.rt-generated-yt,
        [rt-video] > div.rt-generated-yt {
          display: none !important;
        }
    
        [data-rt-video]:not(.rt-video-loading):not(.rt-video-active) .plyr,
        [rt-video]:not(.rt-video-loading):not(.rt-video-active) .plyr { 
          display: none !important; 
        }
        
        [data-rt-video].rt-video-loading .plyr,
        [rt-video].rt-video-loading .plyr,
        [data-rt-video].rt-video-active .plyr,
        [rt-video].rt-video-active .plyr { 
          display: block !important;
          position: absolute !important; 
          inset: 0 !important; 
          width: 100% !important; 
          height: 100% !important; 
          z-index: 10 !important; 
          background: #131313 !important; 
          opacity: 1 !important;
          border-radius: inherit; 
        }
        
        [data-rt-video] [data-rt-video-thumbnail],
        [data-rt-video] [rt-video-thumbnail],
        [rt-video] [data-rt-video-thumbnail],
        [rt-video] [rt-video-thumbnail] {
          position: absolute !important;
          inset: 0 !important;
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          z-index: 20 !important;
          transition: opacity 0.4s ease !important;
          border-radius: inherit;
        }
    
        [data-rt-video] [data-rt-video-button],
        [data-rt-video] [rt-video-button],
        [rt-video] [data-rt-video-button],
        [rt-video] [rt-video-button] {
          z-index: 21 !important;
          transition: opacity 0.3s ease !important;
        }
    
        [data-rt-video].rt-video-loading [data-rt-video-button],
        [data-rt-video].rt-video-loading [rt-video-button],
        [rt-video].rt-video-loading [data-rt-video-button],
        [rt-video].rt-video-loading [rt-video-button],
        [data-rt-video].rt-video-active [data-rt-video-button],
        [data-rt-video].rt-video-active [rt-video-button],
        [rt-video].rt-video-active [data-rt-video-button],
        [rt-video].rt-video-active [rt-video-button],
        [data-rt-video].rt-video-loading [data-rt-video-thumbnail],
        [data-rt-video].rt-video-loading [rt-video-thumbnail],
        [rt-video].rt-video-loading [data-rt-video-thumbnail],
        [rt-video].rt-video-loading [rt-video-thumbnail],
        [data-rt-video].rt-video-active [data-rt-video-thumbnail],
        [data-rt-video].rt-video-active [rt-video-thumbnail],
        [rt-video].rt-video-active [data-rt-video-thumbnail],
        [rt-video].rt-video-active [rt-video-thumbnail] {
          opacity: 0 !important;
          pointer-events: none !important;
        }
    
        [data-rt-video].rt-video-loading,
        [rt-video].rt-video-loading,
        [data-rt-video].rt-video-active,
        [rt-video].rt-video-active,
        [data-rt-video].rt-video-loading .plyr__video-wrapper,
        [rt-video].rt-video-loading .plyr__video-wrapper,
        [data-rt-video].rt-video-active .plyr__video-wrapper,
        [rt-video].rt-video-active .plyr__video-wrapper {
          cursor: default !important;
        }
    
        [data-rt-video] .plyr__controls button,
        [rt-video] .plyr__controls button,
        [data-rt-video] .plyr__controls input,
        [rt-video] .plyr__controls input,
        [data-rt-video] .plyr__controls [data-plyr],
        [rt-video] .plyr__controls [data-plyr] {
          cursor: pointer !important;
        }
        
        [data-rt-video] .plyr__video-wrapper,
        [rt-video] .plyr__video-wrapper {
          position: absolute !important; 
          inset: 0 !important; 
          width: 100% !important; 
          height: 100% !important; 
          border: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          background: transparent !important;
          overflow: hidden !important; 
          border-radius: inherit;
          container-type: size;
          transition: opacity 0.5s ease !important; 
        }
    
        [data-rt-video].rt-video-loading .plyr__video-wrapper,
        [rt-video].rt-video-loading .plyr__video-wrapper {
          opacity: 0 !important; 
        }
    
        [data-rt-video].rt-video-active .plyr__video-wrapper,
        [rt-video].rt-video-active .plyr__video-wrapper {
          opacity: 1 !important; 
        }
    
        [data-rt-video] .plyr:not(.plyr--fullscreen-active) .plyr__video-wrapper video,
        [rt-video] .plyr:not(.plyr--fullscreen-active) .plyr__video-wrapper video {
          position: absolute !important; 
          top: 50% !important;
          left: 50% !important;
          width: 102% !important; 
          height: 102% !important; 
          object-fit: cover !important; 
          transform: translate(-50%, -50%) !important;
          border: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          pointer-events: none !important; 
        }
    
        [data-rt-video] .plyr:not(.plyr--fullscreen-active) .plyr__video-wrapper iframe,
        [rt-video] .plyr:not(.plyr--fullscreen-active) .plyr__video-wrapper iframe {
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          width: max(102cqw, 181.34cqh) !important;
          height: max(102cqh, 57.38cqw) !important;
          transform: translate(-50%, -50%) !important;
          border: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          max-width: none !important;
          max-height: none !important;
          pointer-events: none !important; 
        }
    
        [data-rt-video] .plyr.plyr--fullscreen-active,
        [rt-video] .plyr.plyr--fullscreen-active,
        [data-rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper,
        [rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper {
          border-radius: 0 !important;
        }
    
        [data-rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper video,
        [rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper video,
        [data-rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper iframe,
        [rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper iframe {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          transform: none !important;
          border: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          max-width: none !important;
          max-height: none !important;
          pointer-events: none !important;
        }
    
        [data-rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper video,
        [rt-video] .plyr.plyr--fullscreen-active .plyr__video-wrapper video {
          object-fit: contain !important;
        }
        
        [data-rt-video] video::-webkit-media-controls,
        [rt-video] video::-webkit-media-controls { display: none !important; }
        
        .plyr--playing .plyr__control--overlaid { display: none; }
        .plyr--video.plyr--hide-controls:hover .plyr__controls { opacity: 1; pointer-events: auto; }
      `;
      document.head.appendChild(customCss);
    }
  };

  const loadScript = () => {
    return new Promise((resolve, reject) => {
      if (window.Plyr) return resolve();
      let script = document.querySelector(`script[src="${PLYR_JS_URL}"]`);
      if (script) {
        script.addEventListener("load", resolve);
        script.addEventListener("error", reject);
        return;
      }
      script = document.createElement("script");
      script.src = PLYR_JS_URL;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const getResponsiveUrl = (rawString) => {
    if (!rawString) return "";
    const parts = rawString.split(",").map((p) => p.trim());
    let defaultUrl = "";
    const breakpoints = [];

    parts.forEach((part) => {
      const match = part.match(/^(\d+):(.*)/);
      if (match) {
        breakpoints.push({
          width: parseInt(match[1], 10),
          url: match[2].trim(),
        });
      } else if (!defaultUrl) {
        defaultUrl = part;
      }
    });

    breakpoints.sort((a, b) => a.width - b.width);
    const currentWidth = window.innerWidth;

    for (let i = 0; i < breakpoints.length; i++) {
      if (currentWidth <= breakpoints[i].width) {
        return breakpoints[i].url;
      }
    }
    return defaultUrl || parts[0];
  };

  const getYouTubeId = (u) => {
    try {
      const url = new URL(u);
      const h = url.hostname.replace(/^www\./, "");
      if (h === "youtu.be")
        return url.pathname.replace(/^\/+/, "").split("/")[0] || "";
      if (h === "youtube.com" || h === "m.youtube.com") {
        if (url.pathname.startsWith("/watch"))
          return url.searchParams.get("v") || "";
        if (url.pathname.startsWith("/embed/"))
          return url.pathname.split("/")[2] || "";
        if (url.pathname.startsWith("/shorts/"))
          return url.pathname.split("/")[2] || "";
      }
    } catch (e) {
      console.error("[rt-video] Invalid URL:", u);
    }
    return "";
  };

  const initSinglePlayer = (wrap) => {
    if (wrap.getAttribute("data-rt-initialized") === "true") return;
    wrap.setAttribute("data-rt-initialized", "true");

    const thumb = wrap.querySelector(
      "[data-rt-video-thumbnail], [rt-video-thumbnail]",
    );
    const btn = wrap.querySelector("[data-rt-video-button], [rt-video-button]");
    if (!thumb || !btn) return;

    const rawSrcAttr = getRtAttr(wrap, "url") || "";
    let SRC = getResponsiveUrl(rawSrcAttr);

    const isAutoplay = getRtAttr(wrap, "autoplay") === "true";
    let isMuted = getRtAttr(wrap, "muted") === "true";

    if (isAutoplay) isMuted = true;

    const isLoop = getRtAttr(wrap, "loop") === "true";
    const rawStart = getRtAttr(wrap, "start");
    const rawEnd = getRtAttr(wrap, "end");
    const startTime = rawStart !== null ? parseFloat(rawStart) : null;
    const endTime = rawEnd !== null ? parseFloat(rawEnd) : null;
    const rawVolume = getRtAttr(wrap, "volume");

    const hasAutopauseAttr = hasRtAttr(wrap, "autopause");
    const isAutopause = hasAutopauseAttr
      ? getRtAttr(wrap, "autopause") === "true"
      : false;

    const rawColor = getRtAttr(wrap, "color") || "#131313";
    const brandColor = rawColor.trim().startsWith("--")
      ? `var(${rawColor.trim()})`
      : rawColor.trim();
    wrap.style.setProperty("--plyr-color-main", brandColor);

    const controlsAttr = getRtAttr(wrap, "controls");
    let controlsArray = [
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "fullscreen",
    ];
    if (controlsAttr !== null) {
      controlsArray =
        controlsAttr.trim() === ""
          ? []
          : controlsAttr.split(",").map((item) => item.trim());
    }

    const YT_ID = getYouTubeId(SRC);
    const PROVIDER = YT_ID ? "youtube" : "mp4";

    const resetState = () =>
      wrap.classList.remove("rt-video-loading", "rt-video-active");
    const setLoadingState = () => {
      wrap.classList.add("rt-video-loading");
      wrap.classList.remove("rt-video-active");
    };
    const setActiveState = () => {
      if (!wrap.classList.contains("rt-video-active")) {
        wrap.classList.remove("rt-video-loading");
        wrap.classList.add("rt-video-active");
      }
    };

    resetState();

    const plyrOptions = {
      debug: false,
      clickToPlay: false,
      storage: { enabled: false },
      controls: controlsArray,
      fullscreen: { enabled: true, fallback: false, iosNative: true },
      muted: isMuted,
      autopause: isAutopause,
      loop: { active: isLoop && startTime === null && endTime === null },
    };

    let player = null;
    let main = null;

    if (PROVIDER === "youtube") {
      const ytc = document.createElement("div");
      ytc.className = "rt-generated-yt";
      wrap.appendChild(ytc);

      ytc.setAttribute("data-plyr-provider", "youtube");
      ytc.setAttribute("data-plyr-embed-id", YT_ID);

      plyrOptions.youtube = {
        rel: 0,
        modestbranding: 1,
        iv_load_policy: 3,
        playsinline: 1,
        controls: 0,
        noCookie: true,
        origin: location.origin,
      };

      if (startTime !== null) plyrOptions.youtube.start = startTime;
      if (endTime !== null) plyrOptions.youtube.end = endTime;

      player = new Plyr(ytc, plyrOptions);
    } else {
      main = document.createElement("video");
      main.className = "rt-generated-video";
      main.setAttribute("playsinline", "");
      main.setAttribute("webkit-playsinline", "");
      main.setAttribute("controls", "");
      main.setAttribute("preload", "metadata");
      wrap.appendChild(main);

      if (startTime !== null || endTime !== null) {
        const tStart = startTime !== null ? startTime : "";
        const tEnd = endTime !== null ? endTime : "";
        const fragment = `t=${tStart},${tEnd}`;

        try {
          const parsedUrl = new URL(SRC, window.location.origin);
          if (parsedUrl.hash) {
            parsedUrl.hash += `&${fragment}`;
          } else {
            parsedUrl.hash = fragment;
          }
          SRC = parsedUrl.toString().replace(window.location.origin, "");
        } catch (e) {
          const prefix = SRC.includes("#") ? "&" : "#";
          SRC += `${prefix}${fragment}`;
        }
      }

      if (!main.getAttribute("src")) main.setAttribute("src", SRC);
      try {
        main.load();
      } catch (e) {
        console.warn("[rt-video] Load error", e);
      }
      player = new Plyr(main, plyrOptions);
    }

    player.on("ready", () => {
      if (rawVolume !== null) {
        const vol = parseFloat(rawVolume);
        player.volume = vol > 1 ? vol / 100 : vol;
      }

      if (
        PROVIDER === "mp4" &&
        startTime !== null &&
        player.currentTime < startTime
      ) {
        player.currentTime = startTime;
      }
    });

    const handleEnded = () => {
      if (isLoop) {
        player.currentTime = startTime !== null ? startTime : 0;
        player.play();
      } else {
        resetState();
        player.currentTime = startTime !== null ? startTime : 0;
      }
    };

    player.on("ended", handleEnded);

    player.on("playing", () => {
      setActiveState();
    });

    player.on("timeupdate", () => {
      const current = player.currentTime;
      const startCheck = startTime !== null ? startTime : 0;

      if (current > startCheck + 0.1 || current > 0.1) {
        setActiveState();
      }

      if (endTime !== null && current >= endTime) {
        if (isLoop) {
          player.currentTime = startCheck;
          player.play();
        } else {
          player.pause();
          handleEnded();
        }
      }
    });

    const attemptPlay = () => {
      if (
        wrap.classList.contains("rt-video-active") ||
        wrap.classList.contains("rt-video-loading")
      )
        return;
      setLoadingState();
      try {
        const playPromise = player.play();
        if (
          playPromise !== undefined &&
          typeof playPromise.catch === "function"
        ) {
          playPromise.catch((error) => {
            resetState();
            console.warn("[rt-video] Playback prevented", error);
          });
        }
      } catch (err) {
        resetState();
      }
    };

    wrap.addEventListener("click", (e) => {
      if (e.target.closest(".plyr__controls")) return;
      e.preventDefault();
      attemptPlay();
    });

    if (isAutoplay && "IntersectionObserver" in window) {
      const autoplayObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (wrap.classList.contains("rt-video-active")) {
                player.play();
              } else {
                attemptPlay();
              }
            } else {
              player.pause();
            }
          });
        },
        { threshold: 0.1 },
      );
      autoplayObserver.observe(wrap);
    }
  };

  const init = async () => {
    const wrappers = document.querySelectorAll("[data-rt-video], [rt-video]");
    if (wrappers.length === 0) return;
    injectStyles();

    try {
      await loadScript();
      let lazyObserver = null;
      if ("IntersectionObserver" in window) {
        lazyObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                initSinglePlayer(entry.target);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "200px" },
        );
      }

      wrappers.forEach((wrap) => {
        const isLazy = getRtAttr(wrap, "lazy") === "true";
        if (isLazy && lazyObserver) {
          lazyObserver.observe(wrap);
        } else {
          initSinglePlayer(wrap);
        }
      });
    } catch (error) {
      console.error("[rt-video] Failed to load Plyr script.", error);
    }
  };

  return { init };
})();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", RtVideo.init);
} else {
  RtVideo.init();
}
